import React from 'react';


export function DeclineComparisonDivider(): React.JSX.Element {
  return (
    <svg
      className="pointer-events-none absolute inset-0 h-full w-full"
      viewBox="0 0 28 76"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
      preserveAspectRatio="none"
    >
      <line
        x1="14"
        y1="0"
        x2="14"
        y2="76"
        stroke="#C3CBDE"
        strokeWidth="1"
        strokeLinecap="round"
        strokeDasharray="4 4"
      />
    </svg>
  );
}

export function DeclineWaveDivider(): React.JSX.Element {
  return (
    <div className="relative h-[22px] w-full shrink-0 bg-white" aria-hidden>
      <svg
        className="absolute bottom-0 left-0 h-[32px] w-full"
        viewBox="0 0 375 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="none"
      >
        <path
          d="M375 32H0V0H0.00195312C0.00748638 2.43865 0.034602 3.88159 0.175781 5.13477C1.63843 18.1161 11.8839 28.3616 24.8652 29.8242C26.4277 30.0002 28.2852 30 32 30H343C346.715 30 348.572 30.0002 350.135 29.8242C363.116 28.3616 373.362 18.1161 374.824 5.13477C374.965 3.88159 374.993 2.43865 374.998 0H375V32Z"
          fill="#F4F6F9"
        />
      </svg>
    </div>
  );
}

const CHEVRON_RIGHT_PATH =
  'M14.1078 12.4757L18.7578 7.82568L17.6001 6.66797L11.7923 12.4757L17.6001 18.2835L18.7578 17.1257L14.1078 12.4757Z';
const CHEVRON_LEFT_PATH =
  'M9.8922 12.4757L5.24219 7.82568L6.3999 6.66797L12.2077 12.4757L6.3999 18.2835L5.24219 17.1257L9.8922 12.4757Z';

export function DeclineChevronRightIcon({
  className,
  direction = 'right',
}: {
  className?: string;
  direction?: 'left' | 'right';
}): React.JSX.Element {
  return (
    <svg
      className={['size-6 shrink-0', className].filter(Boolean).join(' ')}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <path
        d={direction === 'right' ? CHEVRON_RIGHT_PATH : CHEVRON_LEFT_PATH}
        fill="#585B7A"
      />
    </svg>
  );
}
